import React, { useState } from "react";
import { createPortal } from "react-dom";
import "./style.scss";

const quickLinkData = {
  contact: {
    title: "Contact Us",
    content:
      "If you have any questions or need support, don’t hesitate to reach out to the EchoVault team at support@echovault.com or call us at 0948 440 803. We’re available Monday to Friday and usually respond within 24 business hours."
  },
  about: {
    title: "About EchoVault",
    content:
      "EchoVault is a modern communication platform that empowers users to connect, collaborate, and build meaningful communities. Our mission is to provide a safe, fast, and user-friendly messaging experience that brings people closer together."
  },
  features: {
    title: "Powerful Features",
    content:
      "- Real-time messaging\n- High-quality voice and video calls\n- Pinned messages, file sharing, and more\nDiscover how EchoVault helps you communicate smarter and faster."
  },
  privacy: {
    title: "Your Privacy Matters",
    content:
      "We are committed to protecting your personal data. All information is securely encrypted and never shared with third parties without your consent. Visit our Privacy Policy page to learn more about how your data is handled."
  },
  terms: {
    title: "Terms of Use",
    content:
      "By using EchoVault, you agree to our terms regarding user conduct, account security, and responsibilities. Please review our full Terms of Service before using the platform."
  },
  faq: {
    title: "Frequently Asked Questions",
    content:
      "- How can I reset my password?\n- Why am I not receiving the verification code?\n- Can I delete my account permanently?\nBrowse the FAQ section to find quick solutions to your most common concerns."
  }
};

const QuickLinkModal = ({ sectionKey, onClose }) => {
  if (!sectionKey) return null;

  const { title, content } = quickLinkData[sectionKey] || {};

  return createPortal(
    <div className="quicklink-modal-overlay" onClick={onClose}>
      <div className="quicklink-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>×</button>
        <h2>{title}</h2>
        <p style={{ whiteSpace: "pre-line" }}>{content}</p>
      </div>
    </div>,
    document.body
  );
};

export default QuickLinkModal;
